// DO NOT PUT SECRETS IN HERE!!!
const test = {
  RSS_LINKS_URL: "https://test-cal.read.ai",
  FRONTEND_URL: "https://test-app.read.ai",
  INTERNAL_API_URL: "https://test-internal.read.ai",
  api: {
    HOST: "https://test-api.read.ai",
  },
  apps: {
    meet: {
      CLIENT_ID: "TEST_MEET_CLIENT_ID",
    },
  },
  tracking: {
    DEBUG: true,
    ENABLED: false,
    GOOGLE_ID: "TEST_GOOGLE_ID",
    MIXPANEL_VERBOSE_LOG: true,
    MIXPANEL_ID: "TEST_MIXPANEL_ID",
    STATSIG_KEY: "TEST_STATSIG_KEY",
  },
};

export type Config = typeof test;
export default test;
